import { StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  pageContainer: {
    width: '100%',
    height: '100%',
    fontFamily: 'MaisonNeue',
    color: '#333333',
    paddingBottom: 30,
  },
  bold: { fontFamily: 'MaisonNeue-Bold' },
  header: {
    paddingTop: 20,
    paddingBottom: 20,
    paddingLeft: 30,
    paddingRight: 30,
    marginBottom: 30,
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
  },
  logo: {
    width: 'auto',
    maxHeight: 30,
    maxWidth: 90,
    height: 30,
  },
  firmLogo: {
    height: 27,
    width: 'auto',
  },
  paragraph: {
    marginBottom: 15,
    lineHeight: 1.2,
    fontSize: 11,
  },
  paragraphItalic: {
    marginBottom: 15,
    lineHeight: 1.2,
    fontSize: 11,
    fontFamily: 'MaisonNeue-BookItalic',
    fontStyle: 'italic',
  },
  italic: {
    lineHeight: 1.2,
    fontSize: 11,
    fontFamily: 'MaisonNeue-BookItalic',
    fontStyle: 'italic',
  },
  list: {
    marginBottom: 15,
    lineHeight: 1.2,
    paddingLeft: 15,
    fontSize: 11,
  },
  pageContent: {
    paddingLeft: 60,
    paddingRight: 60,
  },
  heading: {
    marginTop: 10,
    marginBottom: 20,
    fontFamily: 'MaisonNeue-Bold',
    color: '#333333',
  },
  topMargin: {
    marginTop: 15,
  },
  footer: {
    position: 'absolute',
    bottom: 20,
    right: 30,
    lineHeight: 1.2,
    fontSize: 10,
    color: '#333333',
  },
});

export default styles;
